export default __webpack_public_path__ + "static/media/ex_img_02.fa6eec09.png";